<template>
  <validation-observer ref="refFormObserver" v-slot="{ handleSubmit }">
    <b-form class="p-2">
      <b-modal
        id="type-alarm-category-filters-modal"
        v-model="isModalOpen"
        no-close-on-esc
        no-close-on-backdrop
      >
        <template #modal-title>
          <h5 class="modal-title text-capitalize text-white">Configurar recordatorio</h5>
        </template>

        <b-row>
          <b-col cols="7" class="my-1 mb-md-0">
            <validation-provider v-slot="{ errors }" name="Minutos" rules="required">
              <b-form-group label="Minutos" label-for="reminder-minutes">
                <b-form-input
                  id="reminder-minutes"
                  v-model="reminderMinutes"
                  :state="errors.length ? false : null"
                  type="number"
                />

                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <template #modal-footer>
          <div class="w-100 rfm-footer">
            <div class="d-flex flex-row align-items-stretch justify-content-between">
              <b-button variant="danger" class="mr-2 mb-0" @click="closeModal">
                {{ $t("actions.cancel") }}
              </b-button>

              <b-button
                variant="primary"
                class="mr-2 mb-0"
                @click="handleSubmit(onSubmit)"
              >
                {{ $t("actions.save") }}
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
    </b-form>
  </validation-observer>
</template>

<script>
import vSelect from "vue-select";
import { ref, watch } from "@vue/composition-api";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "ReminderModal",
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isModalOpen = ref(props.isOpen);
    const reminderMinutes = ref(null);

    const { refFormObserver, getValidationState, resetForm } = formValidation();

    watch(
      () => props.isOpen,
      (value) => {
        if (value) {
          isModalOpen.value = value;
          reminderMinutes.value = null;
        }
      }
    );

    const closeModal = () => {
      isModalOpen.value = false;
    };

    const onSubmit = () => {
      isModalOpen.value = false;

      emit("update:reminder-minutes", reminderMinutes.value);
    };

    return {
      isModalOpen,
      closeModal,
      reminderMinutes,
      onSubmit,
    };
  },
};
</script>

